import React from 'react';
import PropTypes from 'prop-types';


export const AlertMessage = ({ message, alertType }) => {
    return (
        <div className={`${alertType}`} role="alert">
           { message }
        </div>
    );
};

AlertMessage.propTypes = {
    /* 
      message for alert component
    */ 
      message: PropTypes.string.isRequired,
    /* 
      type for alert component
    */ 
      alertType: PropTypes.string.isRequired,
  }
  
AlertMessage.defaultProps = {
    /*
        default value if breadcrumb list is not given
    */
    message: 'Simple Alert Message',
    /*
        default value if breadcrumb list is not given
    */
    alertType: 'alert alert-primary',
}